<script lang="ts" setup>
const { notification, close } = useNotification()

// const getIcon = (type) => {
//   switch (type) {
//     case 'success':
//       return 'icon:success'
//     case 'error':
//       return 'icon:warning'
//     default:
//       return 'icon:info'
//   }
// }
</script>

<template>
  <!-- <div> -->
  <Transition name="fade">
    <div
      v-if="notification"
      class="notification"
    >
      <!-- UiMessage start -->
      <p
        :class="[
          'message message--' + (notification?.type || 'default'),
        ]"
      >
        <!-- <Icon
          :name="getIcon(notification?.type)"
        /> -->
        <span class="message__text">{{ notification.message }}</span>
      </p>
      <!-- UiMessage end -->

      <button
        type="button"
        class="notification__close"
        @click="close()"
      >
        <Icon
          name="icon:close"
        />
      </button>
    </div>
  </Transition>
  <!-- </div> -->
</template>

<style>
@import url("~layers/app/assets/css/transitions/fadeIn.css");
@import url("~layers/app/components/App/Notification.css");
</style>
